var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareemBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.522981 7.5611L3.2745 10.9462C3.40909 11.1029 3.64835 11.1342 3.79789 10.9932C3.94743 10.8521 3.97734 10.6014 3.84275 10.4447L1.28563 7.29468C1.30058 7.29468 1.31554 7.31035 1.33049 7.31035L13.2936 7.31035C13.503 7.31035 13.6675 7.13797 13.6675 6.91856C13.6675 6.69916 13.503 6.52677 13.2936 6.52677L1.34545 6.52677C1.33049 6.52677 1.31554 6.54245 1.30058 6.54245L3.85771 3.39245C3.99229 3.22007 3.97734 2.98499 3.81284 2.84395C3.73808 2.78126 3.6633 2.74992 3.57358 2.74992C3.4689 2.74992 3.36423 2.79693 3.28946 2.89096L0.537935 6.27603C0.268764 6.58946 0.268764 7.24767 0.522981 7.5611Z",
    fill: "#001411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareemBackButton);
export default __webpack_public_path__ + "static/media/careem-back-button.4aa58e3b6a7820379fa5009a82cb3a68.svg";
export { ForwardRef as ReactComponent };